import { Controller } from "@hotwired/stimulus"
import Sortable from 'sortablejs'

export default class extends Controller {
  static values = {
    url: String
  }

  connect() {
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      onEnd: this.end.bind(this),
    })
  }

  end(event) {
    let id = event.item.dataset.id
    let url = this.urlValue.replace(":id", id)
    let formData = new FormData()
    formData.append("position", event.newIndex + 1)
    fetch(url, {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: formData
    })
  }
}
